export default "__VITE_ASSET__QlpYmWgL__"